import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container, Row, Col } from "react-bootstrap";

import Divider from "../../Divider";

import "./styles.scss";

const Header = ({ children, className }) => {
  return (
    <>
      <Row className={classNames("mydpd-main-header", "m-0", className)}>
        <Col>
          <Container>{children}</Container>
        </Col>
      </Row>
      <Divider />
    </>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Header;
